
// [ISSUE-736] 20250829
// a bit after the launch of form versioning last year we decided to decouple
// location querying from form actions, because it would often take several
// seconds to query the location and slow down form loads and saves.  with
// full offline we have gone to a middleware in the frontend that queries the
// location on an interval and keeps the latest value cached for use by the
// form and other components.
// it appears that calls to formAppRelay.updateUserLocation() were never
// used for anything substantial anyway.  for backwards compatibility we'll
// return the latest query when it is requested by the form, but otherwise we
// can ignore these old "legacy" formats.

/**
 * @deprecated: 20251120
 */
export enum LegacyLocationPermission {
	Granted = 'granted',
	Denied = 'denied',
	// builds < 52 did not have Capactior Geolocation
	NoSoftwareSupport = 'no-software-support',
}

export interface Location {
	latitude: number
	longitude: number
	accuracy: number
}

/**
 * @deprecated: 20251120
 */
export interface LegacyLocationQuery {
	permission: LegacyLocationPermission
	location?: Location
	updatedAt: number
}
